
<div class="row" [ngStyle]="{'margin':'5px','margin-top':'20vh'}">
<div class="col-sm-2"></div>

<div class="col-sm-8">



 <form [formGroup]="signupForm">




<mat-card [ngStyle]="{'opacity': '1'}">


  <mat-card-header>


<mat-form-field style="width:100%" appearance="outline" [ngStyle]="{'margin-right': '2px'}">
    <mat-label>Objet du message</mat-label>
    <span matSuffix ><mat-icon>mail</mat-icon></span>
    <input matInput formControlName="Ctrl0">
</mat-form-field>

  </mat-card-header>

<mat-card-content [ngStyle]="{'margin-left': '30px'}">
	
<mat-form-field style="width:100%" appearance="outline" >
    <mat-label>Message</mat-label>
    <textarea matInput  formControlName="Ctrl1"

cdkTextareaAutosize
        cdkAutosizeMinRows="15"
        cdkAutosizeMaxRows="5"


    ></textarea>
</mat-form-field>



</mat-card-content>

<mat-card-actions [ngStyle]="{'margin-top':'-30px','margin-bottom':'5px'}">
	

    <button mat-flat-button color="warn"  [ngStyle]="{'margin-left': '37.5px'}" 
(click)="pay()" [disabled]="signupForm.invalid"><mat-icon>mail</mat-icon>&nbsp;&nbsp;ENVOYER</button>

</mat-card-actions>
<mat-card-footer  [ngStyle]="{'margin-left': '37.5px', 'margin-bottom':'10px'}" *ngIf="display_message">  Message envoyé ! nous revenons vers vous dès que nous le pouvons.</mat-card-footer>
</mat-card>


  </form>

</div></div>




